import { Component, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { UpdateDto } from '@dto';
import { LatestUpdateService } from '@services';

@Component({
  imports: [TranslatePipe],
  selector: 'monitor-ui',
  styleUrls: ['./monitor-ui.component.scss'],
  templateUrl: './monitor-ui.component.html',
})
export class MonitorUiComponent implements OnInit {
  subscriptions = [];
  updates: string[];

  latestUpdates: UpdateDto[];

  constructor(private updateService: LatestUpdateService) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.updateService.setUpdates().subscribe(data => {
        this.latestUpdates = data;
      }),
    );
  }

  goTo(url: string): void {
    window.open(url, '_blank');
  }
}
